const calculateTotalFromCellByAlias = (alias, data) =>
  data.reduce((acc, { value, alias: cellAlias }) => (cellAlias === alias ? acc + Number(value) : acc), 0);

export default calculateTotalFromCellByAlias;
